"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentGetMetadataResponsePayloadToJSON = exports.AttachmentGetMetadataResponsePayloadFromJSONTyped = exports.AttachmentGetMetadataResponsePayloadFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AttachmentGetMetadataResponsePayloadFromJSON(json) {
    return AttachmentGetMetadataResponsePayloadFromJSONTyped(json, false);
}
exports.AttachmentGetMetadataResponsePayloadFromJSON = AttachmentGetMetadataResponsePayloadFromJSON;
function AttachmentGetMetadataResponsePayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
        'attachmentResponse': !runtime_1.exists(json, 'AttachmentResponse') ? undefined : _1.AttachmentResponseFromJSON(json['AttachmentResponse']),
    };
}
exports.AttachmentGetMetadataResponsePayloadFromJSONTyped = AttachmentGetMetadataResponsePayloadFromJSONTyped;
function AttachmentGetMetadataResponsePayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'AttachmentResponse': _1.AttachmentResponseToJSON(value.attachmentResponse),
    };
}
exports.AttachmentGetMetadataResponsePayloadToJSON = AttachmentGetMetadataResponsePayloadToJSON;
//# sourceMappingURL=AttachmentGetMetadataResponsePayload.js.map